import Http from "./Http";

//•	GET Latest Products:  https://vietpro-shop-api.onrender.com/api/v1/products
//•	GET Featured Products:  https://vietpro-shop-api.onrender.com/api/v1/products?featured=true

export const getProducts = (config) => {
  return Http.get("/products", config);
};
//•	GET Categories http://localhost:8000/api/v1/categories (Lấy danh mục sản phẩm:)
export const getCategories = (config) => {
  return Http.get("/categories", config);
};
//•	GET Products by Category ID http://localhost:8000/api/v1/categories/5f8a0b89dd21e25249b6295c/products (Lấy danh sách sản phẩm theo ID danh mục:)
export const getProductsCategory = (id, config) => {
  return Http.get(`/categories/${id}/products`, config);
};
//•	GET Category Details by ID http://localhost:8000/api/v1/categories/5f8a0b89dd21e25249b6295c (Lấy thông tin danh mục theo ID)
export const getCategory = (id, config) => {
  return Http.get(`/categories/${id}`, config);
};

//•	GET Products By Name/ID:  https://localhost:8000/api/v1/products?name=iphone
export const getProduct = (id, config) => {
  return Http.get(`/products/${id}`);
};
//•	GET Comments by ID
export const getCommentsProduct = (id, config) => {
  return Http.get(`/products/${id}/comments`, config);
};
export const createCommentProduct = (id, data, config) => {
  return Http.post(`/products/${id}/comment`, data, config);
};
export const createOrder = (data) => {
  return Http.post(`/order`, data);
  //http://localhost:8000/api/v1/order
};
//• GET sliders
export const getSliders = (config) => {
  return Http.get(`/sliders`, config);
};
//• GET banners
export const getBanners = (config) => {
  return Http.get(`/banners`, config);
};
export const registerCustomer = (data) => {
  return Http.post("/customers/register", data);
};
export const loginCustomer = (data) => Http.post(`/customers/login`, data);
export const logoutCustomer = (id) => Http.get(`/customers/${id}/login`);
export const orderList = (id) => Http.get(`/customers/${id}/orders`);
export const orderDetails = (id) => Http.get(`/customer/orders/${id}`);
export const orderCanceled = (id) =>
  Http.get(`/customer/orders/${id}/canceled`);
export const updateCustomer = (id, data) =>
  Http.post(`/customers/${id}/update`, data);
export const refreshToken = () => Http.get(`/customers/refreshtoken`);
